import { useEffect } from "react";

export function useManifest(shopId?: string, themeColor?: string) {
  useEffect(() => {
    // baza (np. "/MT" na produkcji, "" lokalnie)
    const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");

    // spróbuj wyciągnąć id z URL-a, jeśli nie podano
    let id = shopId;
    if (!id) {
      const q = new URL(window.location.href).searchParams.get("id");
      if (q && /^\d+$/.test(q)) id = q;
    }
    if (!id) id = "1"; // fallback

    // ---- manifest ----
    let link = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "manifest";
      document.head.appendChild(link);
    }
    link.href = `${base}/manifest-${id}.json`;

    // ---- theme-color ----
    let meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "theme-color";
      document.head.appendChild(meta);
    }
    if (themeColor) meta.content = themeColor;

    // ---- apple touch icon ----
    let apple = document.querySelector<HTMLLinkElement>('link[rel="apple-touch-icon"]');
    if (!apple) {
      apple = document.createElement("link");
      apple.rel = "apple-touch-icon";
      document.head.appendChild(apple);
    }
    apple.href = `${base}/icon-180.png`; 
    // albo per sklep: `${base}/assets/${id}/icon-180.png`

    // ---- iOS meta: full-screen i status bar ----
    let cap = document.querySelector<HTMLMetaElement>('meta[name="apple-mobile-web-app-capable"]');
    if (!cap) {
      cap = document.createElement("meta");
      cap.name = "apple-mobile-web-app-capable";
      document.head.appendChild(cap);
    }
    cap.content = "yes";

    let status = document.querySelector<HTMLMetaElement>('meta[name="apple-mobile-web-app-status-bar-style"]');
    if (!status) {
      status = document.createElement("meta");
      status.name = "apple-mobile-web-app-status-bar-style";
      document.head.appendChild(status);
    }
    status.content = "default"; // lub "black-translucent"

    let title = document.querySelector<HTMLMetaElement>('meta[name="apple-mobile-web-app-title"]');
    if (!title) {
      title = document.createElement("meta");
      title.name = "apple-mobile-web-app-title";
      document.head.appendChild(title);
    }
    title.content = `Sklep ${id}`;

  }, [shopId, themeColor]);
}
